import { UserOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FC } from 'react';
import { AiOutlineFileAdd } from 'react-icons/ai';

interface IAddNewOrderRow {
  addNewRow(): void;
  newReceiverRow(): void;
}

const AddNewOrderRow: FC<IAddNewOrderRow> = ({ addNewRow, newReceiverRow }) => {
  return (
    <div className='flex justify-center gap-2 mt-2 '>
      <Tooltip title='افزودن یک فرستنده و گیرنده جدید به سفارش'>
        <div
          className='flex items-center justify-center gap-1 p-2 text-sm border rounded-lg cursor-pointer hover:border-t-primary-color inherit-color w-fit text-t-primary-color bg-t-bg-color border-t-border-color-base'
          onClick={addNewRow}>
          <AiOutlineFileAdd /> سفارش جدید
        </div>
      </Tooltip>
      {/* <Tooltip title='افزودن سطر جدید به سفارش با تمام اطلاعات بالا'>
        <div
          className='flex items-center justify-center gap-1 p-2 text-sm border rounded-lg cursor-pointer hover:border-t-primary-color inherit-color w-fit text-t-primary-color bg-t-bg-color border-t-border-color-base'
          onClick={copyRow}>
          <AiOutlineCopy /> کپی
        </div>
      </Tooltip> */}
      {/* <div
        className='flex items-center justify-center gap-1 p-2 text-sm border rounded-lg cursor-pointer hover:border-t-primary-color inherit-color w-fit text-t-primary-color bg-t-bg-color border-t-border-color-base'
        onClick={addNewRow}>
        <UserOutlined /> فرستنده جدید
      </div> */}
      <Tooltip title='کپی فرستنده و کالای بالا در سطر جدید برای افزودن گیرنده'>
        <div
          className='flex items-center justify-center gap-1 p-2 text-sm border rounded-lg cursor-pointer hover:border-t-primary-color inherit-color w-fit text-t-primary-color bg-t-bg-color border-t-border-color-base'
          onClick={newReceiverRow}>
          <UserOutlined /> گیرنده جدید
        </div>
      </Tooltip>
    </div>
  );
};

export default AddNewOrderRow;
